import {useEffect, useState} from 'react'

export default function UseDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value)

    useEffect(
        () => {
            const handler = setTimeout(() => {
                setDebouncedValue(value)
            }, delay)

            return () => {
                clearTimeout(handler)
            }
        },
        // eslint-disable-next-line
        [value]
    )

    return debouncedValue
}
